<template>
  <div class="dashboard-panel p-new-leads">
    <div>
      <div class="panel-header">
        <h2>New Leads</h2>
        <p class="help">
          {{ matches.length || 0 }} NEW
        </p>
      </div>

      <div class="panel-content">
        <v-data-table
          :headers="[
            { text: 'Lead Name', value: 'deal.user.fullName' },
            { text: 'Email', value: 'deal.user.email' },
            { text: 'Status', value: 'status' },
          ]"
          :items="matches.slice(0, 6)"
          disable-sort disable-pagination disable-filtering
          hide-default-footer
          no-data-text="No data found with this criteria"
        >

          <template #item.status="{ item, value }">
            <LeadStatusIndicator
              :status="value"
              @clicked="promptStatusDialog(item.id)"
            />
          </template>
        </v-data-table>
      </div>

      <div class="panel-footer">
        <router-link
          class="default-btn link"
          :to="{
            name: 'OrganizationLeads',
            params: { organizationId },
          }"
        >
          View All Leads
        </router-link>
      </div>
    </div>

    <DialogUpdateLeadStatus
      v-if="showStatusDialog"
      @cancel="showStatusDialog = null"
      @submit="updateLeadStatus"
    />
  </div>
</template>

<script>
import DialogUpdateLeadStatus from '@/modules/shared/components/DialogUpdateLeadStatus'
import LeadStatusIndicator from '@/modules/shared/components/LeadStatusIndicator'

export default {
  name: 'PanelNewLeads',
  components: {
    DialogUpdateLeadStatus,
    LeadStatusIndicator,
  },
  props: {
    organizationId: String,
    matches: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    showStatusDialog: null,
  }),

  methods: {
    promptStatusDialog (id) {
      this.showStatusDialog = { id }
    },

    updateLeadStatus (status) {
      this.$emit('updateLeadStatus', {
        id: this.showStatusDialog.id,
        status,
      })
      this.showStatusDialog = null
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-panel {
  .panel-header {
    padding: 0 15px 15px;
    flex-direction: column;

    h2, p { margin-bottom: 0; }
  }
  .panel-content {
    margin-bottom: auto;
  }

  .v-data-table {
    padding: 0;

    ::v-deep {
      table {
        width: 100%;
      }

      thead {
        background-color: #F0F0F0;
      }

      tbody tr {
        border-top: thin solid rgba(0, 0, 0, 0.12);
        border-bottom: thin solid rgba(0, 0, 0, 0.12);
        box-shadow: none;
      }
    }
  }
}

</style>
